<template>
  <path
    d="M13 7.00024H11V9.00024H13V7.00024ZM13 11.0002H11V13.0002H13V11.0002ZM17 11.0002H15V13.0002H17V11.0002ZM3 5.00024V19.0002C3 20.1002 3.9 21.0002 5 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V5.00024C21 3.90024 20.1 3.00024 19 3.00024H5C3.9 3.00024 3 3.90024 3 5.00024ZM18 19.0002H6C5.45 19.0002 5 18.5502 5 18.0002V6.00024C5 5.45024 5.45 5.00024 6 5.00024H18C18.55 5.00024 19 5.45024 19 6.00024V18.0002C19 18.5502 18.55 19.0002 18 19.0002ZM13 15.0002H11V17.0002H13V15.0002ZM9 11.0002H7V13.0002H9V11.0002Z"
  />
</template>
